import { ref, computed } from 'vue'
import { quotesService } from '../../services/quotesService.js'

/**
 * Composable pour détecter les doublons d'une demande de devis
 */
export function useDuplicateDetection(quoteId) {
  const duplicates = ref([])
  const loadingDuplicates = ref(false)

  const hasDuplicates = computed(() => duplicates.value.length > 0)
  const hasExactDuplicates = computed(() => duplicates.value.some(d => d.matchType === 'exact'))

  const loadDuplicates = async () => {
    loadingDuplicates.value = true
    try {
      const data = await quotesService.getDuplicates(quoteId)
      duplicates.value = data.duplicates || []
    } catch (err) {
      console.error('Erreur lors du chargement des doublons:', err)
      duplicates.value = []
    } finally {
      loadingDuplicates.value = false
    }
  }

  return {
    duplicates,
    loadingDuplicates,
    hasDuplicates,
    hasExactDuplicates,
    loadDuplicates
  }
}
